export default function syncRunHoursService($http, appSettings, packagesService, EquipmentService) {
  'ngInject';

  const syncRunHours = (installationId, datapointId, runHours) => {
    const url = `${appSettings.InReachApiInstallationsEndpoint}/${installationId}/runhours`;
    const syncBody = {baseTag: datapointId, value: runHours};
    return $http.post(url, syncBody);
  };

  const getSyncRunHoursTag = packageIds =>
    packagesService
      .getPackageByIds(packageIds)
      .then(response => {
        const pkgWithSyncDatapoint = response.data.find(pkg => pkg.allowsRunHoursSync);
        return pkgWithSyncDatapoint ? pkgWithSyncDatapoint.runHoursSync : null;
      })
      .catch(() => false);

  const getLastReportedRunHours = (equipmentId, tag) => {
    return EquipmentService.getEquipmentSeries(equipmentId, tag);
  };

  const service = {
    syncRunHours: syncRunHours,
    getSyncRunHoursTag: getSyncRunHoursTag,
    getLastReportedRunHours: getLastReportedRunHours
  };

  return service;
}
